"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      '& > *:not(:last-child)': {
        marginBottom: theme.spacing(2)
      }
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);
/**
 * Groups a set of form controls into a row or column format.
 */

var FormGroup = function FormGroup(_ref) {
  var children = _ref.children;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, children);
};

FormGroup.propTypes = {
  /** The content of the component. */
  children: _propTypes["default"].node.isRequired
};
var _default = FormGroup;
exports["default"] = _default;